module.exports = __webpack_public_path__ + "img/SKMA_speedlimit.3746ca8a.jpg";